class StationListItem {
    constructor(options) {
        this.station = options.station;
        this.stationDetailComponent = null;
        this.$ = options.$;
        this.stationDetailComponentOptions = options.stationDetailComponentOptions;
        
        this.$element = this.buildHtml(options.stationDetailComponent);
        this.$element.data("list-item", this);
        this.$element.toggleClass("display-none", true);
        
        this.relevant = false;
        this._visible = false;
    }
    
    get visible() {
        return this._visible;
    }
    
    set visible(value) {
        let willBeVisible = !!value;
        
        this.$element.toggleClass("display-none", !willBeVisible);
        
        this._visible = willBeVisible;
    }
    
    set highlight(value) {
        this.$element.toggleClass("station-list__item--highlighted", !!value);
    }
    
    update(station) {
        if (this.stationDetailComponent !== null) {
            this.stationDetailComponent.update(station);
        }
        
        this.station = station;
    }
    
    buildHtml(stationDetailComponent) {
        let options = this.stationDetailComponentOptions;
        options.station = this.station;
        this.stationDetailComponent = new stationDetailComponent(options);
        let html = this.stationDetailComponent.render();
        return this.$(html);
    }
}

export default StationListItem;